<template>
    <div class="tab_content">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="转出开始"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="转出结束"></el-date-picker>
                </div>
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="in_start_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="转入开始"></el-date-picker>
                    ~
                    <el-date-picker v-model="in_end_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="转入结束"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.status" placeholder="转库状态">
                    <el-option :value="1" :label="'已完成'"></el-option>
                    <el-option :value="2" :label="'待转库'"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.order_sn" placeholder="转库单号"></el-input>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.creator_id" placeholder="制单人" @visible-change="getSelectList('creator')">
                    <el-option v-for="list in selectMap.creator" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.transfer_id" placeholder="确认人" @visible-change="getSelectList('transfer')">
                    <el-option v-for="list in selectMap.transfer" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.out_warehouse_id" placeholder="转出仓库" @visible-change="getSelectList('outwarehouse')">
                    <el-option v-for="list in selectMap.outwarehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.in_warehouse_id" placeholder="转入仓库" @visible-change="getSelectList('inwarehouse')">
                    <el-option v-for="list in selectMap.inwarehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.out_warehouse_local" placeholder="转出库位"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.in_warehouse_local" placeholder="转入库位"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.remark" placeholder="备注"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisibleOut=!filterDialogVisibleOut;scene='move.storage.list';isGlobal=false;filter=filter;"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',warehouse-combind-edit,')!=-1" @click="dialogVisible=!dialogVisible;isGlobal = true;">新增转库</el-button>
                <el-button class="funcPublicBtn" @click="batchDel" v-if="module.indexOf(',customer-del,')!=-1">删除</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="move.storage.list"  :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @recall="recall" @rowClick="rowClick" @getTableEdit="edit" @getTableDelete="del"></tabletem>
            </div>
            <div class="totalCal no_print">
                <div class="totalNumber">合计：</div>
                <div class="totalNumber">{{totalObj.count}}单</div>
                <div class="totalNumber">立方数: {{totalObj.cube}}m³</div>
            </div>  
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC  eldialogTransfer eldialogWidth" :modal="false" :title="'货物转库'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <div class="outAndInTitle dialogForm" style="padding-bottom: 7px;">
                                待转出库存明细
                                <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible;scene = 'move.storage.out';columnType=[1];isGlobal = true;getBillColumn();"></div>
                            </div>
                            <el-table :data="form_params.out.detail" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="80">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStock=!dialogVisibleStock" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <template v-for="(item) in filterA">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.indexOf(item.field)" :key="item.field" :label="item.name"
                                            :sortable="false"
                                            :width="item.width && item.width>80 ?item.width:80+ 'px'"
                                            align="left"
                                            show-overflow-tooltip
                                        >
                                        <template slot-scope="scope">
                                            <span>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="form_params.out.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="80">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStock=!dialogVisibleStock" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="转出仓库" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.warehouse }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="库位" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse_local,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.warehouse_local }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="合同号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',contract_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.contract_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="规格" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',spec,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.spec }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="方数" prop="cube" width="94" show-overflow-tooltip v-if="billColumn.indexOf(',cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                            </el-table> -->
                            <div class="transferType">
                                <!-- <input placeholder="输入拆卸的包数" type="number" class="transferNumberInput" @input="inputTransferNumber" v-model="transferNumber" v-if="transferType==2"/> -->
                            </div>
                            <div class="outAndInHander">
                                <div class="outAndInTitle">待转入库存明细</div>
                                <div class="editBtn">
                                    <el-button class="funcPublicBtn funcPublicBtnChecked" style="line-height: 27px;margin-bottom: 5px;" @click="choose">选择仓库</el-button>
                                    <el-button class="fun" style="line-height: 27px;margin-bottom: 5px;" @click="openbusinessRelation">关联转库费用</el-button>
                                    <div v-if="fee_list!=''&&fee_list.length>0" class="clearfix" style="float:left;">
                                        <div class="newFee" v-for="(list,index) in fee_list" :key="'_'+index">
                                            {{list.fee_name+':  ￥'+list.amount}}
                                            <img src="../../assets/top-delete-suspension.png"  class="newFeeImg" @click="delOutFee(index)"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleB=!filterDialogVisibleB;scene = 'move.storage.in';columnType=[2];isGlobal = true;getBillColumn();"></div>
                            </div>
                            <el-table :data="form_params.in.detail" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrogB">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filterB">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.indexOf(item.field)" :key="item.field" :label="item.name"
                                            :sortable="false"
                                            :width="item.width && item.width>90 ?item.width:90+ 'px'"
                                            align="left"
                                            show-overflow-tooltip
                                        >
                                        <template slot-scope="scope">
                                            <span>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="form_params.in.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="转库状态" width="80" show-overflow-tooltip>
                                    <template>
                                        {{status }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="转入仓库" width="110" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.in_warehouse }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="合同号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',contract_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.contract_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="规格" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',spec,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.spec }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="方数" prop="cube" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="费用平摊" width="94" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.cost}}</span>
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="transferConfirm(0)">锁定待转</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="openNewWarehousing(1)">确认入库</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibles" class="eldialog eldialogC  eldialogTransfer eldialogWidth" :modal="false" :title="'货物转库'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <div class="outAndInTitle dialogForm" style="padding-bottom: 7px;">
                                待转出库存明细
                                <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible;scene = 'move.storage.out';isGlobal = true;getBillColumn();"></div>
                            </div>
                            <el-table :data="form_params.out.detail" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="80" v-if="isCanEdit">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStock=!dialogVisibleStock" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <template v-for="(item) in filterA">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.indexOf(item.field)" :key="item.field" :label="item.name"
                                            :sortable="false"
                                            :width="item.width && item.width>80 ?item.width:80+ 'px'"
                                            align="left"
                                            show-overflow-tooltip
                                        >
                                        <template slot-scope="scope">
                                            <span>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="form_params.out.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="80" v-if="isCanEdit">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStock=!dialogVisibleStock" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="转出仓库" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.warehouse }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="库位" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse_local,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.warehouse_local }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="合同号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',contract_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.contract_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="供单号" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',original_bale,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_bale }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="规格" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',spec,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.spec }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="方数" prop="cube" width="94" show-overflow-tooltip v-if="billColumn.indexOf(',cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                            </el-table> -->
                            <div class="transferType" ></div>
                            <div class="outAndInHander">
                                <div class="outAndInTitle">待转入库存明细</div>
                                <div class="editBtn">
                                    <el-button class="funcPublicBtn funcPublicBtnChecked" style="line-height: 27px;margin-bottom: 5px;" v-if="isCanEdit" @click="choose">选择仓库</el-button>
                                    <el-button class="fun" style="line-height: 27px;margin-bottom: 5px;" @click="openbusinessRelation"  v-if="isCanEdit">关联转库费用</el-button>
                                     <div v-if="fee_list.length>0" class="clearfix" style="float:left;margin-bottom: 5px;">
                                        <div class="newFee" v-for="(list,index) in fee_list" :key="'_'+index">
                                            {{list.fee_name+':  ￥'+list.amount}}
                                            <img src="../../assets/top-delete-suspension.png"  class="newFeeImg" @click="delOutFee(index)"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleB=!filterDialogVisibleB;scene = 'move.storage.in';columnType=[2];isGlobal = true;getBillColumn();"></div>
                            </div>
                            <el-table :data="form_params.in.detail" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrogB">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filterB">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.indexOf(item.field)" :key="item.field" :label="item.name"
                                            :sortable="false"
                                            :width="item.width && item.width>90 ?item.width:90+ 'px'"
                                            align="left"
                                            show-overflow-tooltip
                                        >
                                        <template slot-scope="scope">
                                            <span>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="form_params.in.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="转库状态" width="80" show-overflow-tooltip>
                                    <template>
                                        {{ status }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="转入仓库" width="110" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.in_warehouse }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="合同号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',contract_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.contract_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="供单号" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',original_bale,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_bale }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="85" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="规格" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',spec,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.spec }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="方数" prop="cube" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="费用平摊单价" width="94" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.cost}}</span>
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5" :readonly="!isCanEdit"></textarea>
                    </div>
                </div>
                    <span class="bottom" v-if="bottom.creator_name">制单人:{{bottom.creator_name}}</span> 
                    <span class="bottom" v-if="bottom.out_time">转出时间:{{bottom.out_time}}</span>
                    <span class="bottom" v-if="bottom.transfer_name">入库人:{{bottom.transfer_name}}</span>
                    <span class="bottom" v-if="bottom.inbound_time">入库时间:{{bottom.inbound_time}}</span>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="transferExport">导出</el-button>
                        <el-button class="funcPublicBtn" v-if="dels"  @click="deleteUpdate">删除</el-button>
                        <el-button class="funcPublicBtn" v-if="isCanEdit" @click="transferConfirmUpdate(0)">锁定待转</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="Edit"  @click="openWarehousing(1)">确认入库</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->

        <!--选择库存START-->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleStock" class="eldialog eldialogStock" width="1160px" :modal="false" title="选择货物" custom-class="full_dialog">
            <transfer-select-stock ref="selectStock" @cancel="dialogVisibleStock=!dialogVisibleStock" @selectData="selectData" @selectAndOut="selectAndOut"></transfer-select-stock>
        </el-dialog>
        <!--选择库存END-->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isCanEditTotalWidth" :dialogvisible="dialogVisibleWidth" :list="widthList" @returnwidth="res=>{this.form_params.in.detail[this.indetailType].width=res;this.calculation(this.indetailType)}" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!--选择仓库 -->
        <el-dialog v-dialog-drag title="选择仓库" :visible.sync="dialogVisibleChoose" width="420px !important" class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item label="转入仓库" class="other_form_item" style="width:90%">
                        <el-select  v-model="sure_params.in_warehouse" placeholder="选择仓库" @input="in_warehouseChange" @visible-change="getSelectList('warehouse')">
                            <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="转入库位" class="other_form_item" style="width:90%">
                        <el-input v-model="sure_params.warehouse_local"></el-input>
                        <!-- <el-select  v-model="sure_params.warehouse_local" placeholder="选择库位"  @visible-change="getSelectList('location')">
                            <el-option v-for="list in selectMap.location" :key="list.id" :value="list.name" :label="list.name"></el-option>
                        </el-select> -->
                    </el-form-item>
                    <el-form-item label="转出时间" class="other_form_item" style="width:90%;padding-bottom: 20px;">
                        <el-date-picker v-model="sure_params.outbound_time"  value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="选择时间"></el-date-picker>
                    </el-form-item>
                </div>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn"  @click="chooseChangeSure(1)">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outChooseVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
         <!--新建确认入库 -->
         <el-dialog v-dialog-drag title="确认入库" :visible.sync="newWarehousingDialogVisible" width="420px !important" class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item label="转入时间" class="other_form_item" style="width:90%;padding-bottom: 20px;">
                        <el-date-picker v-model="sure_params.inbound_time"  value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="选择时间"></el-date-picker>
                    </el-form-item>
                </div>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" :loading="isSaveing"  @click="transferConfirm(warehouseType)">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outNewWarehousingDialogVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
         <!--确认入库 -->
        <el-dialog v-dialog-drag title="确认入库" :visible.sync="warehousingDialogVisible" width="420px !important" class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item label="转入时间" class="other_form_item" style="width:90%;padding-bottom: 20px;">
                        <el-date-picker v-model="sure_params.inbound_time"  value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="选择时间"></el-date-picker>
                    </el-form-item>
                </div>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn"  @click="transferConfirmUpdate(warehouseType)">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outWarehousingDialogVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
         <!--添加费用START-->
        <el-dialog v-dialog-drag :visible.sync="businessRelation" class="eldialog eldialogLine" :modal="false" title="添加成本费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="businessRelationForm" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="businessRelationForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="outFeeSelectFunc" clearable>
                            <el-option v-for="list in outFeeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="businessRelationForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="businessRelationForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="businessRelationForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="businessRelationForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="businessRelation=!businessRelation" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked"  @click="newOutFee">确认</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加费用END-->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filterA" :scene="sceneA" :isGlobal="true" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <filter-fields :tableData="filterB" :scene="sceneB" :isGlobal="true" :filterDialogVisible="filterDialogVisibleB" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleB = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="move.storage.list" :filterDialogVisible="filterDialogVisibleOut" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleOut = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import bus from "../../eventBus";
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    const initBusinessRelationForm = {
        order_id: "",
        order_sn: "",
        fee_date: "",
        fee_id: "",
        fee_name: "",
        payee: "",
        amount: "",
        is_invoice: "",
        remark: ""
    };
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                dialogVisibleWidth:false,
                dialogVisibleChoose:false,
                newWarehousingDialogVisible:false,//新建时确认入库
                warehousingDialogVisible:false,//确认入库
                warehouseType:'',
                isShowMore:false,
                widthList:[],
                filter:[],
                filterDialogVisibleOut:false,
                filterA:[],
                filterB:[],
                filtersA:[],
                filtersB:[],
                filterDialogVisible:false,
                filterDialogVisibleB:false,
                isGlobal:false,
                billColumn:"",
                scene:"move.storage.out",
                copy_filter:"",
                isCanEditTotalWidth:false,
                upodateType:2,
                indetailType:"",
                start_time:"",
                end_time:"",
                in_start_time:"",
                in_end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    in_start_time:"",
                    in_end_time:"",
                    order_sn:"",
                    status:"",
                    creator_id:"",
                    transfer_id:"",
                    out_warehouse_id:"",
                    in_warehouse_id:"",
                    page:1,
                    per_page:50
                },
                breedList:[],
                gradeList:[],
                warehouseList:[],
                selectMap:{
                    breed:[],
                    grade:[],
                    warehouse:[],
                    attribute:[],
                    location:[],
                    creator:[],
                    transfer:[],
                    inwarehouse:[],
                    outwarehouse:[],
                },
                dialogVisible:false,
                dialogVisibles:false,
                centerDialogVisible:false,
                dialogVisibleStock:false,
                last_page:1,
                total:0,
                selectRow:[],
                form_params:{
                    out:{
                        detail:[
                            {
                                id:"",
                                bale_no:"",
                                contract_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                width:[],
                                pieces:"",
                                original_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:"",
                                color:"",
                                attribute:"",
                                sales_price:"",
                                cost:""
                            }
                        ]
                    },
                    in:{
                        detail:[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                contract_no:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                color_id:"",
                                attribute_id:"",
                                sales_price:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                width:[],
                                pieces:"",
                                original_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                in_warehouse:"",
                                remark:"",
                                status_text:"",
                                cost:""
                            }
                        ]
                    },
                    remark:""
                },
                isCanEdit:false,
                transferNumber:"",
                transferType:"",//1.组装 2.拆卸
                list:[],
                tableCol:[
                    {colName:"转库单号",colKey:"order_sn",colWidth:160,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"转出日期",colKey:"out_time",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"转入日期",colKey:"in_time",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"转库状态",colKey:"status_text",htmlNodeFunc(row) {
                            let _color = row['status_color'];
                            return `<span style="color:${_color}">${row[this.colKey]}</span>`;
                        },colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"转库费用",colKey:"amount",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"转出仓库",colKey:"out_warehouse",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"转入仓库",colKey:"in_warehouse",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"转出库位",colKey:"out_warehouse_local",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"转入库位",colKey:"in_warehouse_local",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"制单人",colKey:"creator_name",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"转库人",colKey:"transfer_name",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"立方数",colKey:"cube",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"操作日期",colKey:"create_time",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:false},
                ],
                totalObj:{},
                listDetail:[],
                errorMessage:"",
                flag:false,
                removeTotalOriginal:"",
                removeOriginal:"",
                removeThicknessOriginal:"",
                removeLengthOriginal:"",
                removePiecesOriginal:"",
                isShowEdit:false,
                sure_params : {
                    in_warehouse:'',
                    warehouse_local:'',
                    outbound_time:new Date(),
                    inbound_time:new Date()
                },
                bottom:{
                    inbound_time:"",
                    creator_name:"",
                    transfer_name:"",
                    out_time:""
                },
                in_warehouse_name:"",
                businessRelation: false,
                businessRelationForm: this.$cloneJson(initBusinessRelationForm),
                feeOutFormRlues: {
                    fee_date: [{required: true, message: '请填写日期', trigger: 'blur'}],
                    order_id: [{required: true, message: '请选择销售单号', trigger: 'blur'}],
                    fee_id: [{required: true, message: '请选择费用名称', trigger: 'blur'}],
                    payee: [{required: true, message: '请填写收款人', trigger: 'blur'}],
                    amount: [{required: true, message: '请填写金额', trigger: 'blur'}],
                    is_invoice: [{required: true, message: '请选择是否开票', trigger: 'blur'}],
                },
                outFeeSelect: [],
                fee_list:[],
                editid:"",
                in_warehouse_id:"",
                warehouse_local:"",
                creator_name:"",
                status:"",
                Edit:"",
                dels:"",
                goodsId:"",
                columnType:[1,2],
                sceneList:[
                    {name:"move.storage.in",number:2},
                    {name:"move.storage.out",number:1}
                ],
                sceneA:"move.storage.out",
                sceneB:"move.storage.in",
                action:'',
                selectWarehouseClick:0,
                isSaveing: false,
            }
        },
        created(){
            this.getSelectList("breed")
            this.getSelectList("grade")
            this.getSelectList("warehouse")
            this.getSelectList("attribute")
            this.getSelectList("color")
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
            this.sceneList.forEach(item=>{
                this.scene = item.name;
                this.columnType = [item.number]
                this.getBillColumn()
            })
        },                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
        methods:{ 
            headDrog(newWidth, oldWidth, column) {
                this.filterA.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.sceneA).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            headDrogB(newWidth, oldWidth, column) {
                this.filterB.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.sceneB).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    cube: 4,//码单立方
                    cost_amount:2,
                },total=>{
                });
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    for(let i=0;i<this.selectRow.length;i++){
                        if(!this.selectRow[i].isDelete){
                            // flag = false;
                            this.tip("选择订单中有不可删除项","warning")
                            return;
                        }else{
                            this.$confirm('是否删除?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            let arr = new Array();
                            this.selectRow.forEach(item=>{
                                arr.push(item.id)
                            })
                            this.postFunc("/erp/move.storage.delete",{ids:arr},()=>{
                                this.tip("删除成功","success")
                                this.getList();
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(()=>{});
                        }
                    }
                }
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                let {columnType} = this.$data;
                this.filterA =[]
                this.filterB =[]
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    if(columnType.indexOf(1)!=-1){
                        this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                        this.filterA = response.data.data.columns;
                        this.filtersA = response.data.data.columns;
                        this.filterB = this.filtersB
                    } 
                    if(columnType.indexOf(2)!=-1){
                        this.tiltingColumn = ","+response.data.data.fields.join(",").toString()+",";
                        this.filterB = response.data.data.columns;
                        this.filtersB = response.data.data.columns;
                        this.filterA = this.filtersA
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=JSON.parse(JSON.stringify(res.list));
                })
            },
            inDetailChangePieces(val){
                if(Number(val)||Number(val)==0){
                    for(let i=0;i<this.form_params.in.detail.length;i++){
                        if(this.form_params.in.detail[i].pieces!=val){
                            this.form_params.in.detail[i].pieces = Number(this.form_params.out.detail[0].pieces)-Number(val)
                        }
                    }
                }
            },
            inDetailChangelayer(val){
                if(!this.isShowEdit){
                    if(Number(val)||Number(val)==0){
                        for(let i=0;i<this.form_params.in.detail.length;i++){
                            if(this.form_params.in.detail[i].layer_number!=val){
                                this.form_params.in.detail[i].layer_number = Number(this.form_params.out.detail[0].layer_number)-Number(val)
                            }
                        }
                    }
                }
            },
            inDetailChangeCube(val){
                if(!this.isShowEdit){
                    if(Number(val)||Number(val)==0){
                       for(let i=0;i<this.form_params.in.detail.length;i++){
                           if(this.form_params.in.detail[i].original_cube!=val){
                               this.form_params.in.detail[i].original_cube = this.keepLimit(this.keepLimit(this.form_params.out.detail[0].original_cube)-this.keepLimit(val))
                           }
                       }
                    }
                }
            },
            //新建时打开
            openNewWarehousing(type){
                this.warehouseType = type;
                this.newWarehousingDialogVisible = true;
            },
            outNewWarehousingDialogVisible(){
                this.newWarehousingDialogVisible = false
            },
            transferConfirm(type){
                if(type==0){
                    this.$confirm('是否确认操作?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        // let flag = this.handle();
                        // if(flag){
                            let obj = new Object();
                            obj.out_stocks=[];
                            this.form_params.out.detail.forEach(item=>{
                                obj.out_stocks.push(item.inventory_id)
                            })
                            obj.in_warehouse =this.sure_params.in_warehouse;
                            obj.warehouse_local = this.sure_params.warehouse_local;
                            obj.outbound_time = this.selectWarehouseClick==1? this.formatTimeZero(this.sure_params.outbound_time):0;
                            obj.remark = this.form_params.remark;
                            if(type==0){
                                obj.submit = 0; 
                            }
                            if(type==1){obj.submit = 1; }
                            obj.fee_list = this.fee_list;
                            // const loading = this.$loading({
                            //     lock: true,//lock的修改符--默认是false
                            //     text: 'Loading',//显示在加载图标下方的加载文案
                            //     spinner: 'el-icon-loading',//自定义加载图标类名
                            //     background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
                            //     target: document.querySelector('#table')//loadin覆盖的dom元素节点
                            // })
                            this.$axios.post("/erp/move.storage.create",obj).then((response) => {
                                // loading.close()
                                if(response.data.code == 0){
                                    this.tip("操作成功","success")
                                    this.dialogVisible=false;
                                    this.outNewWarehousingDialogVisible();
                                    this.getList(obj)
                                }
                                if(response.data.code == 1300||response.data.code == 1100){
                                    this.tip(response.data.message,"warning")
                                }
                                if(response.data.code == 400){
                                    this.openConfirm(obj);
                                }   
                            }).catch((error) => {
                                window.console.log(error);
                            })
                        // }
                    }).catch(()=>{});
                }else{
                    // let flag = this.handle();
                    // if(flag){
                        let obj = new Object();
                        obj.out_stocks=[];
                        this.form_params.out.detail.forEach(item=>{
                            obj.out_stocks.push(item.inventory_id)
                        })
                        obj.in_warehouse =this.sure_params.in_warehouse;
                        obj.warehouse_local = this.sure_params.warehouse_local;
                        obj.outbound_time = this.selectWarehouseClick==1? this.formatTimeZero(this.sure_params.outbound_time):0;
                        obj.inbound_time = this.formatTimeZero(this.sure_params.inbound_time);
                        obj.remark = this.form_params.remark;
                        if(type==0){
                            obj.submit = 0; 
                        }
                        if(type==1){obj.submit = 1; }
                        obj.fee_list = this.fee_list;
                        this.isSaveing = true;
                        this.$axios.post("/erp/move.storage.create",obj).then((response) => {
                            this.isSaveing = false;
                            if(response.data.code == 0){
                                this.tip("操作成功","success")
                                this.dialogVisible=false;
                                this.outNewWarehousingDialogVisible();
                                this.getList()
                            }
                            if(response.data.code == 1300||response.data.code ==1100){
                                this.tip(response.data.message,"warning")
                            }
                            if(response.data.code == 400){
                                this.openConfirm(obj);
                            }   
                        }).catch((error) => {
                            window.console.log(error);
                        })
                    // }
                }
            },
            openConfirm(obj){
                this.$confirm('存在不同仓库的转出库存,确定是否继续操作?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.action = 'Y';
                    if(this.action!=''){
                        obj.action = this.action;
                    }
                    this.postFuncLoading('/erp/move.storage.create',obj,()=>{
                        this.tip("操作成功","success")
                        this.dialogVisible=false;
                        this.outNewWarehousingDialogVisible();
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{
                    // this.action = 'N';
                    // this.auditCompleted();
                });
            },
            openWarehousing(type){
                this.warehouseType = type;
                this.warehousingDialogVisible = true;
            },
            transferConfirmUpdate(type){
                if(type==0){
                     this.$confirm('是否确认操作?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // let flag = this.handle();
                    // if(flag){
                        let obj = new Object();
                        obj.out_stocks=[];
                        this.form_params.out.detail.forEach(item=>{
                            obj.out_stocks.push(item.inventory_id)
                        })
                        if(this.sure_params.in_warehouse==''){
                            obj.in_warehouse =this.in_warehouse_id
                        }else{
                            obj.in_warehouse =this.sure_params.in_warehouse;//this.in_warehouse_id
                        }
                        if(this.sure_params.warehouse_local==''){
                            obj.warehouse_local = this.warehouse_local;
                        }else{
                            obj.warehouse_local = this.sure_params.warehouse_local;
                        }
                        obj.outbound_time = this.selectWarehouseClick==1? this.formatTimeZero(this.sure_params.outbound_time):0;
                        obj.remark = this.form_params.remark;
                        obj.id = this.editid
                        if(type==0){
                            obj.submit = 0; 
                        }
                        if(type==1){obj.submit = 1; }
                        obj.fee_list = this.fee_list;
                        // this.postFuncLoading("/erp/move.storage.update",obj,()=>{
                        //     this.tip("操作成功","success")
                        //     this.warehousingDialogVisible = false;
                        //     this.dialogVisibles=false;
                        //     this.getList()
                        // },error=>{
                        //     this.tip(error.data.message,"warning")
                        // })
                        this.$axios.post("/erp/move.storage.update",obj).then((response) => {
                            if(response.data.code == 0){
                                this.tip("操作成功","success")
                                this.warehousingDialogVisible = false;
                                this.dialogVisibles=false;
                                this.getList()
                            }
                            if(response.data.code == 1300){
                                this.tip(response.data.message,"warning")
                            }
                            if(response.data.code == 400){
                                this.openConfirmUpdate(obj);
                            }   
                        }).catch((error) => {
                            window.console.log(error);
                        })
                    // }
                }).catch(()=>{});
                }else{
                    // let flag = this.handle();
                    // if(flag){
                        let obj = new Object();
                        obj.out_stocks=[];
                        this.form_params.out.detail.forEach(item=>{
                            obj.out_stocks.push(item.inventory_id)
                        })
                        if(this.sure_params.in_warehouse==''){
                            obj.in_warehouse =this.in_warehouse_id
                        }else{
                            obj.in_warehouse =this.sure_params.in_warehouse;//this.in_warehouse_id
                        }
                        if(this.sure_params.warehouse_local==''){
                            obj.warehouse_local = this.warehouse_local;
                        }else{
                            obj.warehouse_local = this.sure_params.warehouse_local;
                        }
                        obj.outbound_time =this.selectWarehouseClick==1? this.formatTimeZero(this.sure_params.outbound_time):0;
                        obj.inbound_time = this.formatTimeZero(this.sure_params.inbound_time);
                        obj.remark = this.form_params.remark;
                        obj.id = this.editid
                        if(type==0){
                            obj.submit = 0; 
                        }
                        if(type==1){obj.submit = 1; }
                        obj.fee_list = this.fee_list;
                        // this.postFuncLoading("/erp/move.storage.update",obj,()=>{
                        //     this.tip("操作成功","success")
                        //     this.warehousingDialogVisible = false;
                        //     this.dialogVisibles=false;
                        //     this.getList()
                        // },error=>{
                        //     this.tip(error.data.message,"warning")
                        // })
                        this.$axios.post("/erp/move.storage.update",obj).then((response) => {
                            if(response.data.code == 0){
                                this.tip("操作成功","success")
                                this.warehousingDialogVisible = false;
                                this.dialogVisibles=false;
                                this.getList()
                            }
                            if(response.data.code == 1300){
                                this.tip(response.data.message,"warning")
                            }
                            if(response.data.code == 400){
                                this.openConfirmUpdate(obj);
                            }   
                        }).catch((error) => {
                            window.console.log(error);
                        })
                    // }
                }
            },
            openConfirmUpdate(obj){
                this.$confirm('存在不同仓库的转出库存,确定是否继续操作?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.action = 'Y';
                    if(this.action!=''){
                        obj.action = this.action;
                    }
                    this.postFuncLoading('/erp/move.storage.update',obj,()=>{
                        this.tip("操作成功","success")
                        this.warehousingDialogVisible = false;
                        this.dialogVisibles=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{
                    // this.action = 'N';
                    // this.auditCompleted();
                });
            },
            transferExport(){
                this.$exportExecl("/erp/move.storage.info.export","货物转库",{id:this.editid})
            },
            choose(){
                this.dialogVisibleChoose = true
            },
            chooseChangeSure(type){
                this.selectWarehouseClick=type;
                let arr = JSON.parse(JSON.stringify(this.form_params.in.detail));
                for(let ke in arr){
                    arr[ke].in_warehouse = this.in_warehouse_name;
                    arr[ke].in_warehouse_local = this.sure_params.warehouse_local;
                }
                this.form_params.in.detail = arr;
                this.dialogVisibleChoose = false;
            },
            outWarehousingDialogVisible(){
                this.warehousingDialogVisible = false
            },
            outChooseVisible(){
                this.dialogVisibleChoose = false
            },
            openbusinessRelation(){
                this.businessRelation = true;
                this.businessRelationForm.fee_date = new Date();
            },
            delOutFee(ind){
                this.fee_list.forEach((item,index)=>{
                    if(index==ind){
                        this.fee_list.splice(index,1)
                    }
                })
            },
            in_warehouseChange(e){
                this.selectMap.warehouse.forEach(item=>{
                    if(item.id==e){
                        this.in_warehouse_name = item.name;
                    }
                })
            },
            outFeeChange(e){
                this.outFeeSelect.forEach(item=>{
                    if(item.id==e){
                        this.businessRelationForm.fee_name = item.name;
                    }
                })
            },
            //获取费用名称
            outFeeSelectFunc(){
                this.postFunc("/erp/purchase.cost.type",{type:1},res=>{
                    this.outFeeSelect=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            newOutFee(){
                for(let key in this.businessRelationForm){
                    if(this.businessRelationForm[key]==""){
                        if(key=="order_id"||key=="order_sn"||key=="remark"){
                            this.pl(key)
                        }else{
                            this.tip("请填写完整信息","warning")
                            return;
                        }
                    }
                }
                this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
                this.fee_list.push(JSON.parse(JSON.stringify(this.businessRelationForm)))
                this.businessRelation=!this.businessRelation;
            },
            handle(type){
                //     this.form_params.in.detail=[];
                //     this.form_params.in.detail.push(JSON.parse(JSON.stringify(this.form_params.out.detail)))                    
                // return true;
            },
            calculationTotalWidth(formNumber){
                let total = "";
                this.form_params.in.detail[formNumber].width.forEach((item)=>{
                    total += !!item.width&&item.width.length>0?item.width.reduce((prev,next)=> Number(prev)+Number(next)):""
                    // &&item.width.length>0&&index<this.form_params.in.detail[formNumber].width.length-1
                    total += !!item.width&&item.width.length>0?",":"";
                })
                total = total.substring(0,total.length-1);
                this.form_params.in.detail[formNumber].original_width_total = total;
            },
            calculation(formNumber){
                this.calculationTotalWidth(formNumber)
                let keepIndex = ",";
                let removeIndex = ",";
                this.form_params.in.detail[formNumber].width.forEach((item,index)=>{
                    if(item.width.length>0){
                        keepIndex += index+",";
                    }else{
                        removeIndex += index+",";
                    }
                })
                let number = formNumber==1?number=0:number=1;
                let otherList = JSON.parse(JSON.stringify(this.removeOriginal));
                if(this.removeThicknessOriginal.split(",").length==1){
                    let inData = 0;
                    if(this.form_params.in.detail[formNumber].width.length>0){
                        inData = (this.form_params.in.detail[formNumber].width[0].width).reduce((prev,next)=>{
                            return Number(prev)+Number(next)
                        })
                    }
                    let cha = Number(this.removeTotalOriginal) - Number(inData)
                    if(otherList.length>0){
                        otherList[0].width = [];
                        otherList[0].width[0] = cha;
                    }
                }else{
                    this.removeOriginal.forEach((item,index)=>{
                        if(removeIndex.indexOf(","+index+",")!=-1){
                            // otherList.push(JSON.parse(JSON.stringify(item)))
                            otherList[index].width = item.width;
                        }else{
                            otherList[index].width = [];
                        }
                    })
                    // this.pl(otherList)
                }
                if(this.transferType==2&&formNumber==0){
                    this.form_params.in.detail[number].width = otherList;
                    this.calculationTotalWidth(number)
                    this.changeOtherData(number,removeIndex)
                    this.calculationCube(number)
                }
                this.changeOtherData(formNumber,keepIndex)
                this.calculationCube(formNumber)
                this.upodateType = 3;
            },
            changeOtherData(formNumber,keepIndex){
                let thicknessList = this.removeThicknessOriginal.split(",");
                if(thicknessList.length>1){
                    let lengthList = this.removeLengthOriginal.split(",");
                    let piecesList = this.removePiecesOriginal.split(",");
                    let thickness = "";
                    let length = "";
                    let pieces = "";
                    thicknessList.forEach((item,index)=>{
                        if(keepIndex.indexOf(","+index+",")!=-1){
                            thickness += thicknessList[index] + ",";
                            length += lengthList[index] + ",";
                            pieces += piecesList[index] + ",";
                        }
                    })
                    this.form_params.in.detail[formNumber].original_thickness = thickness.substring(0,thickness.length-1);
                    this.form_params.in.detail[formNumber].original_length = length.substring(0,length.length-1);
                    this.form_params.in.detail[formNumber].pieces = pieces.substring(0,pieces.length-1);
                }
            },
            calculationCube(formNumber){
                let cal_cube = 0;
                let thickness = this.form_params.in.detail[formNumber].original_thickness.split(",");
                let length = this.form_params.in.detail[formNumber].original_length.split(",");
                let widthT = this.form_params.in.detail[formNumber].original_width_total.split(",");
                widthT.forEach((item,index)=>{
                    cal_cube += (Number(thickness[index])/100)*length[index]*(Number(widthT[index])/100)
                })
                this.form_params.in.detail[formNumber].original_cube = this.keepLimit(cal_cube);
            },
            listDetailInAdd(){
                let data = JSON.parse(JSON.stringify(this.form_params.in.detail[0]))
                data.original_cube = "";
                this.form_params.in.detail.push(data)
            },
            listDetailDelete(index){
                this.form_params.out.detail.splice(index,1)
                if(this.form_params.out.detail.length<=0){
                    this.form_params.out.detail.push({id:"",bale_no:"",contract_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:""})
                }
            },
            reset(){
                this.start_time="";
                this.end_time="";
                this.in_start_time="";
                this.in_end_time="";
                this.params={
                    start_time:"",
                    end_time:"",
                    in_start_time:"",
                    in_end_time:"",
                    order_sn:"",
                    status:"",
                    creator_id:"",
                    transfer_id:"",
                    out_warehouse_id:"",
                    in_warehouse_id:"",
                    page:1,
                    per_page:50
                    }
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.params.in_start_time=this.formatTimeZero(this.in_start_time);
                this.params.in_end_time=this.formatTimeZero(this.in_end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/move.storage.list",this.params,res=>{
                    this.totalObj=res.data.data.total;
                    this.filter = res.data.data.column;
                    this.last_page=parseInt(res.data.data.list.last_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.list=res.data.data.list.data;
                    this.list.forEach((item,index)=>{
                        this.list[index].out_time = this.formatTime(item.out_time+"000")
                        if(item.in_time==0){
                            this.list[index].in_time = ''
                        }else{
                            this.list[index].in_time = this.formatTime(item.in_time+"000")
                        }
                        if(item.create_time==0){
                            this.list[index].create_time = ''
                        }else{
                            this.list[index].create_time = this.formatTime(item.create_time+"000")
                        }
                        if( this.list[index].power_operation_list.isEdit==1){
                            item.isEdit=true;
                        }
                        if( this.list[index].power_operation_list.isDelete==1){
                            item.isDelete=true;
                        }
                        if( this.list[index].power_operation_list.isRevoke==1){
                            item.isRevoke=true;
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            excelExport(){
                this.$exportExecl("/erp/move.storage.export","货物转库",this.params)
            },
            del(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    // let id = new Array();
                    let arr = [id]
                    this.postFunc("/erp/move.storage.delete",{ids:arr},()=>{
                        this.tip("删除成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            deleteUpdate(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    let arr = [this.goodsId]
                    this.postFunc("/erp/move.storage.delete",{ids:arr},()=>{
                        this.tip("删除成功","success")
                        this.dialogVisibles=false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            edit(obj){
                this.editid = obj;
                this.isCanEdit = true
                this.postFunc("/erp/move.storage.get",{id:obj},res=>{
                    this.form_params.out.detail=res.data.data.out_stocks;
                    this.form_params.in.detail=res.data.data.in_stocks;
                    this.in_warehouse_id = res.data.data.in_warehouse_id;
                    this.warehouse_local = res.data.data.in_warehouse_local;
                    this.status = res.data.data.status;
                    this.bottom.creator_name = res.data.data.creator_name;
                    this.bottom.out_time = this.formatTime(res.data.data.out_time+"000");
                    this.bottom.transfer_name = res.data.data.transfer_name;
                    this.bottom.inbound_time = this.formatTime(res.data.data.inbound_time+"000");
                    this.Edit = res.data.data.power_operation_list.isEdit;
                    this.dels = res.data.data.power_operation_list.isDelete;
                    this.goodsId = res.data.data.id;
                    if(this.status==1){
                        this.status = '已完成'
                    }else{
                        this.status = '待转库'
                    }
                    this.dialogVisibles=true;
                    this.fee_list = res.data.data.fee_list;
                    this.form_params.remark=res.data.data.remark;
                    for(let ke in this.form_params.in.detail){
                        this.form_params.in.detail[ke].in_warehouse = res.data.data.in_warehouse;
                    }
                },()=>{})
            },
            //选择库存信息
            selectData(row){
                this.listDetailSet(row)
            },
            selectAndOut(row){
                this.listDetailSet(row)
                this.dialogVisibleStock = !this.dialogVisibleStock;
            },
            listDetailSet(row){
                let rows=JSON.parse(JSON.stringify(row));
                rows.forEach(item=>{
                    item.warehouse_local =  item.storage_location;
                    item.in_warehouse = item.in_warehouse;
                    item.color_id = item.color_id == 0 ? '' : item.color_id
                    item.attribute_id = item.attribute_id == 0 ? '' : item.attribute_id
                })
                if(rows.length<=0){
                    return;
                }
                if(this.form_params.out.detail.length==1){
                    if(this.form_params.out.detail[0].id==""){
                        this.form_params.out.detail=rows;
                        // return;
                    }
                }
                if(this.form_params.out.detail.length==1){
                    if(this.form_params.in.detail[0].id==""){
                        this.form_params.in.detail=rows;
                        // return;
                    }
                }
                this.form_params.out.detail=this.form_params.out.detail.concat(rows)
                this.form_params.in.detail=this.form_params.out.detail.concat(rows)
                let result = [];
                let obj = {};
                for(let ke in this.form_params.in.detail){
                    this.form_params.in.detail[ke].cost = 0 ;
                }
                let data=JSON.parse(JSON.stringify(this.form_params.out.detail))
                let lists=JSON.parse(JSON.stringify(this.form_params.in.detail))
                for(var i =0; i<data.length; i++){
                    if(!obj[data[i].id]){
                        result.push(data[i]);
                        obj[data[i].id] = true;
                    }
                }
                for(var i =0; i<lists.length; i++){
                    if(!obj[lists[i].id]){
                        result.push(lists[i]);
                        obj[lists[i].id] = true;
                    }
                }
                this.form_params.out.detail=result;
                this.form_params.in.detail=result;
                this.transferType="";
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            recall(id){
                this.list.forEach(item=>{
                    if(item.id == id){
                        this.$confirm('是否确定撤回到"待转库"状态?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.postFuncLoading("/erp/move.storage.revoke",{id:id},()=>{
                                this.tip("撤销成功","success")
                                this.getList();
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(()=>{});
                    }
                })
               
            },
            rowClick(obj){
                this.postFunc("/erp/move.storage.get",{id:obj.id},res=>{
                    this.in_warehouse_id = res.data.data.in_warehouse_id;
                    this.warehouse_local = res.data.data.in_warehouse_local;
                    this.status = res.data.data.status;
                    this.bottom.creator_name = res.data.data.creator_name;
                    this.bottom.out_time = this.formatTime(res.data.data.out_time+"000");
                    this.bottom.transfer_name = res.data.data.transfer_name;
                    this.bottom.inbound_time = this.formatTime(res.data.data.inbound_time+"000");
                    this.form_params.out.detail=res.data.data.out_stocks;
                    this.form_params.in.detail=res.data.data.in_stocks;
                    this.dialogVisibles=true;
                    this.Edit = obj.row.isEdit;
                    this.dels = obj.row.isDelete;
                    this.goodsId = res.data.data.id;
                    this.editid = obj.row.id;
                    if(this.status==1){
                        this.status = '已完成'
                    }else{
                        this.status = '待转库'
                    }
                    this.isCanEdit=false;
                    for(let ke in this.form_params.in.detail){
                        this.form_params.in.detail[ke].in_warehouse = res.data.data.in_warehouse;
                    }
                    this.fee_list = res.data.data.fee_list;
                    this.form_params.remark=res.data.data.remark;
                },()=>{})
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            getRow(row){
                this.selectRow=row;
            },
            toggleSelection(row) {
                this.$refs.outBoundDetailTable.toggleRowSelection(row);
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(val){
                if(!val){
                    //this.form_params=this.resetJson(this.form_params)
                    this.form_params.out.detail=[];
                    this.form_params.in.detail=[];
                    this.form_params.remark="";
                    this.fee_list = [];
                    this.status = '';
                    this.sure_params ={in_warehouse:'',warehouse_local:'',outbound_time:new Date(),inbound_time:new Date()}
                    let obj = {id:"",bale_no:"",contract_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:""}
                    this.form_params.out.detail.push(JSON.parse(JSON.stringify(obj)))
                    this.form_params.in.detail.push(JSON.parse(JSON.stringify(obj)))
                    this.isCanEdit=false;
                    this.selectWarehouseClick=0;
                }
            },
            "dialogVisibles":function(val){
                if(!val){
                    //this.form_params=this.resetJson(this.form_params)
                    this.form_params.out.detail=[];
                    this.form_params.in.detail=[];
                    this.form_params.remark="";
                    this.fee_list = [];
                    this.status ='';
                    this.sure_params ={in_warehouse:'',warehouse_local:'',outbound_time:new Date(),inbound_time:new Date()}
                    let obj = {id:"",bale_no:"",contract_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:""}
                    this.form_params.out.detail.push(JSON.parse(JSON.stringify(obj)))
                    this.form_params.in.detail.push(JSON.parse(JSON.stringify(obj)))
                    this.isCanEdit=false;
                    this.selectWarehouseClick=0;
                }
            },
            "dialogVisibleStock":function(val){
                if(!val){
                    this.$refs.selectStock.resetSelect();
                }
            },
            "centerDialogVisible":function(val){
                if(!val){
                    this.refuse=this.resetJson(this.refuse)
                }
            },
            'businessRelation':function(val){
                if(!val){
                  this.businessRelationForm=this.$cloneJson(initBusinessRelationForm)
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    .outAndInTitle{padding:10px 0;padding-right: 20px;padding-top: 5px;}
    // dialog START
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .eldialogBack.eldialogC .dialogFlow{max-height: unset}
    .eldialogBack .remarkBox{width:1090px;box-sizing: border-box;}
    .transferType{padding:10px 0;}
    .transferNumber{display: inline-block;}
    .transferNumberInput{width:150px;height: 33px;line-height: 33px;font-size: 12px;border-radius: 3px;border:1px solid #ccc;outline: none;padding:0 10px;}
    .bottom{padding-right: 20px;}
    .outAndInHander{position: relative;display: flex;}

    // dialog ENDout
</style>
